module.exports = __webpack_public_path__ + "static/media/human-resources.68d586cc.png";